import { Box, Divider, Typography } from '@mui/material';

interface SessionDividerProps {
  date: string;   // ISO date string
  label: string;  // session preview text (first user message), used when no title yet
  title?: string | null;  // AI-generated or user-renamed short title, preferred over label
}

const MAX_LABEL = 50;

export function SessionDivider({ date, label, title }: SessionDividerProps) {
  const formatted = new Date(date).toLocaleDateString('en-AU', { month: 'short', day: 'numeric' });
  const summary = title || label;
  const truncated = summary.length > MAX_LABEL ? `${summary.slice(0, MAX_LABEL)}…` : summary;
  const text = truncated ? `${formatted} · ${truncated}` : formatted;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 2, px: 1 }}>
      <Divider sx={{ flex: 1 }} />
      <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap', fontSize: '0.7rem' }}>
        {text}
      </Typography>
      <Divider sx={{ flex: 1 }} />
    </Box>
  );
}
